/** Shared stacking order — keep list toolbars below modal overlays. */
export const Z_INDEX = {
  LIST_TOOLBAR: 30,
  LIST_DROPDOWN: 40,
  MODAL_BACKDROP: 99999,
  MODAL: 100000,
  MODAL_DROPDOWN: 100010,
};
